import * as React from 'react';

import { Modal } from '@spotnana/blocks/src/Modal';

import { footer_wrapper } from './styles';
import PolicyModalFooter from './PolicyModalFooter';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  hasActionButtons?: boolean;
  onContinue?: () => void;
  title: string;
  children: React.ReactNode;
}

const PolicyModal = ({
  isOpen,
  onClose,
  isLoading,
  onContinue,
  hasActionButtons,
  title,
  children,
}: IProps): JSX.Element => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      header={{ title }}
      footer={{
        content: (
          <div css={footer_wrapper}>
            {hasActionButtons && <PolicyModalFooter onClose={onClose} isLoading={isLoading} onContinue={onContinue} />}
          </div>
        ),
      }}
      variant="large"
      data-testid="policy-modal"
    >
      {children}
    </Modal>
  );
};

export default PolicyModal;
